module.exports = __webpack_public_path__ + "img/roll-btn.153279e4.png";